import React from 'react'
import './Index.scss'
import Heading from "src/components/Heading/Heading"
import Paragraph from "src/components/Paragraph/Paragraph"
import Card from "src/components/Card/Card"
import 'swiper/css'
import Container from "src/components/Container/Container"
import Carousel from "src/components/Carousel/Carousel"
import Footer from "src/components/Footer/Footer"
import StickyButton from "src/components/StickyButton/StickyButton"
import SnowLines from "src/components/SnowLines/SnowLines"
import { runTypograph } from "src/helpers"

const Index = () => {

    return (
        <div className={"index"}>
            <Container containerOuterClassName={"index__main-container"}>
                <div className={"hero"}>
                    <picture>
                        <source srcSet={`/main/hero-desktop.png`} media="(min-width: 1280px)"/>
                        <img
                            className={"hero__image"}
                            src={`/main/hero-mobile.png`}
                            alt=""
                        />
                    </picture>
                </div>
                <SnowLines
                    isIndex={true}
                />
            </Container>
            <Container
                containerOuterClassName={"index__second-container--outer"}
                containerInnerClassName={"index__second-container--inner"}
            >
                <Heading size={1} className={"center index__heading"}>
                    Департамент
                    <br/>
                    новогоднего настроения
                </Heading>
                <Paragraph variant={1} className={"center index__description"}>
                    Проверь свою интуицию в AI-игре
                    <br className={"br--mobile"}/>{" "}
                    и выиграй полезные призы
                </Paragraph>
                <div className={"index__card-container"}>
                    <Card>
                        <Paragraph variant={1} className={"white"}>
                            {runTypograph(`Сотрудники айти- и диджитал-компаний поделились с нами новогодним вишлистом — а тебе
                            нужно
                            выяснить, какие подарки они загадали. За правильные ответы
                            поделимся карьерными
                            гайдами.`)}{" "}
                            <span className={"wavy"}>
                                {runTypograph(`А если
                        отгадаешь всё, то сможешь выиграть курсы от Синхронизации — онлайн-лектория.`)}</span>
                        </Paragraph>
                    </Card>
                    <Card>
                        <Paragraph variant={1} className={"white"}>
                            {runTypograph(`В игре 5 раундов: можно угадывать подарки сразу или задавать уточняющие вопросы — мы
                            ответим
                            «да» или «нет».`)}
                        </Paragraph>
                    </Card>
                </div>
            </Container>
            <Container
                containerOuterClassName={"index__with-who-we-play--outer"}
                containerInnerClassName={"index__with-who-we-play--inner"}
            >
                <Heading size={1} className={"index__heading white center"}>С кем играем</Heading>
                <Paragraph variant={1} className={"index__description white center"}>
                    {runTypograph(`В нашем департаменте девять компаний — и вот новогодние пожелания от каждой`)}
                </Paragraph>
                <Carousel/>
            </Container>
            <Footer/>
            <StickyButton/>
        </div>
    )
}

export default Index